export default "__VITE_ASSET__BiKa1D5z__"